import React, { useCallback, useState } from "react";
import { Switch } from "@heroui/react";

/**
 * Component to render a switch with the ability to be toggled
 * @param disabled: boolean to determine if the switch should be disabled
 * @param isChecked: boolean to determine if the switch should be checked
 * @param handleSwitchChange: function to handle the switch change
 * @returns
 */
export default function PermissionSwitch({
  disabled = false,
  isChecked,
  handleSwitchChange,
}: {
  disabled?: boolean;
  isChecked: boolean;
  handleSwitchChange: (checked: boolean) => void;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Use the new value directly from the UI control to avoid stale toggles
  const onChange = useCallback(
    async (newValue: boolean) => {
      setIsSubmitting(true);
      await handleSwitchChange(newValue);
      setIsSubmitting(false);
    },
    [handleSwitchChange],
  );

  return (
    <Switch
      color="primary"
      isSelected={isChecked}
      isDisabled={disabled || isSubmitting}
      onValueChange={onChange}
      aria-label="Permission toggle"
    />
  );
}
